export default __webpack_public_path__ + "static/media/HHCTeaser.d33d9208.mov";